import pluralize from "pluralize";
import {FiAlertCircle} from "react-icons/fi";

import {Alert} from "@/components/alert/Alert.tsx";
import {ActionDialog} from "@/components/overlay/ActionDialog.tsx";
import {AnalyzerUpgradeModalProps} from "@/pages/analyzer/Analyzer.types.ts";

import styles from "./AnalyzerUpgradeModal.module.scss";

export const AnalyzerUpgradeModal = ({statuses, canPurchase, onClose}: AnalyzerUpgradeModalProps) => (
  <ActionDialog
    show={statuses.length > 0}
    size="lg"
    title="Upgrade to add new Checks"
    titleClassName="text-center w-100 py-3 pulseTextH1Bold pulse-color-gray-800"
    hasConfirmButton={canPurchase}
    confirmBtnText="Upgrade Subscription"
    cancelBtnText="Close"
    showBorders
    onConfirm={() => {
      window.open("/billing?action=subscribe", "_blank");
      onClose();
    }}
    onCancel={onClose}
  >
    <div className={styles.body}>
      {statuses.map((status) => (
        <Alert
          key={status.tierKey}
          icon={FiAlertCircle}
          variant="error"
          className="mb-0"
          callout={`You have reached your account limit of ${status.limit} ${pluralize(status.limitName, status.limit)}`}
        >
          Upgrade now to allocate more {pluralize(status.limitName)} to your account.
        </Alert>
      ))}
      {!canPurchase && (
        <div>Ask your account owner to upgrade your plan, or deselect some Checks to fit your plan.</div>
      )}
    </div>
  </ActionDialog>
);
